export default __webpack_public_path__ + "static/media/it-gif3.ab1c0b97.gif";